"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9487 3.6838a1 1 0 0 0-1.7808-.2385L12.4648 9h-6.028a1 1 0 0 1-.7683-.3598L3.7682 6.3598A1 1 0 0 0 2 7v13c0 .5523.4477 1 1 1h4c.5523 0 1-.4477 1-1v-2h3v2c0 .5523.4477 1 1 1h4c.5523 0 1-.4477 1-1v-6.5858l.0742-.0742c1.3974 1.1179 3.5005.8273 4.4647-.7153l1.7959-2.8736-4.4849-3.3636-.9012-2.7037zm-3.8619 6.4888 2.6111-3.9166.3534 1.0602A1 1 0 0 0 17.4 7.8l3.2652 2.4489-.8223 1.3158c-.3171.5072-1.0056.6245-1.4727.2508L16.9258 10.66 15.75 11.8358l-1.6632-1.6632zM12.0858 11h-5.649A2.9998 2.9998 0 0 1 4.132 9.9206L4 9.762V19h2v-2c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1v2h2v-5.0858L12.0858 11z"
  })];
};

exports.default = _default;